<app-content-box>
  <div class="header-container">
    <h5 class="management-title">{{ labels.TITLE }}</h5>
    <div class="buttons-up">
      <button
        *ngIf="active_users_view"
        class="invite-button button-up"
        mat-flat-button
        color="primary"
        (click)="openInviteUser()"
      >
        {{ labels.INVITE_USER }}
      </button>
      <button
        *ngIf="active_users_view"
        class="toggle-active-button button-up"
        mat-flat-button
        color="secondary"
        (click)="toggleActiveUsersView()"
      >
        {{ labels.SEE_INACTIVE_USERS }}
      </button>
      <button
        *ngIf="!active_users_view"
        class="toggle-active-button button-up"
        mat-flat-button
        color="secondary"
        (click)="toggleActiveUsersView()"
      >
        {{ labels.SEE_ACTIVE_USERS }}
      </button>
    </div>
  </div>
  <div class="">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortData($event)"
    >
      <!-- Full Name Column -->
      <ng-container matColumnDef="full_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="full_name">
          {{ labels.USER_NAME }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.full_name }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="email">
          {{ labels.USER_EMAIL }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <!-- CRM Column -->
      <ng-container matColumnDef="crm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="crm">
          {{ labels.USER_CRM }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.crm }}</td>
      </ng-container>

      <!-- CRM_state Column -->
      <ng-container matColumnDef="crm_state">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="crm_state">
          {{ labels.USER_CRM_STATE }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.crm_state }}</td>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="role">
          {{ labels.USER_ROLE }}
        </th>
        <td mat-cell *matCellDef="let user">
          {{ roleModel.fromNumber(user.role) }}
        </td>
      </ng-container>

      <!-- Tenant Column -->
      <ng-container matColumnDef="tenant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="tenant">
          {{ labels.USER_TENANT }}
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.tenant?.name || "-" }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ labels.ACTIONS }}</th>
        <td mat-cell *matCellDef="let user">
          <button
            mat-flat-button
            color="primary"
            (click)="openEditUserDialog(user)"
          >
            {{ labels.EDIT_USER }}
          </button>
          <button
            *ngIf="active_users_view"
            mat-flat-button
            color="warn"
            (click)="toggleActivateUser(user)"
          >
            {{ labels.INACTIVATE_USER }}
          </button>
          <button
            *ngIf="!active_users_view"
            mat-flat-button
            color="warn"
            (click)="toggleActivateUser(user)"
          >
            {{ labels.ACTIVATE_USER }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let user; columns: displayedColumns"
        (click)="isMobile && openEditUserDialog(user)"
      ></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[]"
      [length]="count"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      (page)="handlePageEvent($event)"
      aria-label="labels.PAGINATOR"
      [hidePageSize]="hidePageSize"
      [showFirstLastButtons]="showFirstLastButtons"
    >
    </mat-paginator>
  </div>
</app-content-box>
